import React from 'react';
import Button from '@material-ui/core/Button';
import {makeStyles} from '@material-ui/core/styles';
import{connect} from 'react-redux';


const useStyles = makeStyles(theme=>({
  google:{backgroundColor:'white',width:'calc(100% - 40px)',marginLeft:'20px',marginTop:'5px',marginBottom:'5px','&:hover':{backgroundColor:'rgba(211, 72, 54, 0.1)'}},
}));


function GoogleLoginButton(props){
  

    const classes=useStyles(props);

    return(
        <div style={{width:'90vw', maxWidth:'500px', display:'flex', justifyContent:'center', alignItems:'center'}}><div style={{width:'300px'}}><Button className={classes.google} variant='contained' onClick={()=>{if(props.gmail==true){props.connectGmail();}else{window.location.href='/login/google?redirect_url='+window.location.href;}}}><img src={(props.gmail==true)?'/images/gmail.png':'/images/GoogleLogo.png'} style={{width:'60px', marginLeft:'-25px', marginRight:'5px', marginTop:'-7px', marginBottom:'-7px'}}/>{(props.gmail==true)?'Connect':"Login with google"}</Button></div></div>
    )

}


export default connect(ss, dd)(GoogleLoginButton);

function ss(state){
  return{}
}

function dd(dispatch){
  return{
    connectGmail:()=>{dispatch({type:'REQUEST_GMAIL_CONNECT'})}
  }
}
